import * as React from "react";

import "./select-type.scss";

import {BlockGuestAccess} from "@Common/logic/block-guest-access";
import {cs}               from "@Common/react/chain-services";
import {consumeContext}   from "@Common/react/context";
import {Load}             from "@Common/react/load";

import {getAddressListTypes, filterAddressListTypes} from "../../mailing-icons/address-list-types";
import {TypesGrid}                                from "../../types-grid/types-grid";

export const SelectType = ({onSelect, branchId, countryCode, eddmUnavailable}) => cs(
    consumeContext("company"),
    ({}, next) => (
        <div className="select-type-02w">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name="Address Lists">
                    Address Lists
                </div>
            </div>
            <div className="content">
                <div className="title" xd-qa-type="label" xd-qa-name="Address Lists Purchase or Upload a New List">
                    Purchase or Upload a New List
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name="Address Lists Upload Options Description">
                    Add a new address list by selecting from our robust audience targeting options or uploading your own list.
                </div>

                {next()}
            </div>
        </div>
    ),
    ["blockGuestAccess", (_, next) => BlockGuestAccess({next})],
    ["branch", ({}, next) => branchId ? cs(
        consumeContext("apis"),
        ({apis}) => Load({
            fetch: () => apis.next.getBranchById(branchId),
            next,
        }),
    ) : cs(
        consumeContext("session"),
        ({session}) => next(session.data?.branch),
    )],
    ["types", ({company, blockGuestAccess, branch}, next) => next(
        getAddressListTypes(company?.prefs?.enableMapBasedMailingSupport)
            .filter((type) => type.checkCountry(countryCode))
            .filter((type) => !(eddmUnavailable && type.value === "saturation"))
            .filter((type) => !(blockGuestAccess && type.value === "CRM"))
            // .filter((type) => ["radius", "upload", "street", "demographics", "saturation", "CRM"].includes(type.value))
            .filter(filterAddressListTypes((t) => branch?.addressListTypes.includes(t)))
    )],
    ({types}) => TypesGrid({types, onSelect}),
);
